﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute,Params } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';
import { CustomerInspectionPlan, CIPToken, CIPDayToken, DailyToken, DailyTokenItem, Plan, GenResponse } from '../../shared/misc-classes';
import { NotificationsService } from 'angular2-notifications';
import { ErrorPopupComponent } from '../../common/error-popup/error-popup.component';

@Component({
  selector: 'app-cust-insp-plan',
  templateUrl: './cust-insp-plan.component.html',
  styleUrls: ['./cust-insp-plan.component.css']
})
export class CustInspPlanComponent implements OnInit {

  editToken:string = '';
  editHeader:string = '';
  editText:string = '';
  editType:string = '';
  editParam1:any;
  editParam2:any;
  planObj:Plan;
  btnName:string = '';
  editRow:CIPToken;
  currMonthDtObj:Date = new Date();
  datatables:CustomerInspectionPlan;
  dCIPDayTokenObj:CIPDayToken;

  isLoading:boolean = false;
  isLoaded:boolean = false;
  isFailed:boolean = false;
  failMessage:string = '';

  selView: number = 1;
  areChangesMade:boolean = false;

  mId:string = "72b9d798-a413-408c-940e-9cd2bfbaa407";
  hasmodaccess:boolean = false;
  daywiseItemList: Array<DailyToken>;

  @ViewChild('childModal') public childModal:ModalDirective;  
  @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;

  constructor(private _dataService:DataService,
              private _activatedRoute:ActivatedRoute, private _notify:NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "Customer Inspection Plan Highlights";

    this._activatedRoute.queryParams.subscribe((params:Params) => {
      if(params['month']){
        this.currMonthDtObj = new Date(parseInt(params['month']));
      }
      this.loadMonthData();
      this.loadPlan();
    });
  }

  checkModAccess():boolean{
    if(this._dataService.mAccess(this.mId) == true){
      this.hasmodaccess = true; 
    }
    else{
      this.hasmodaccess = false; 
    }
    return this.hasmodaccess;
  }
  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  hasReadAccess(_pid:string){
    return this._dataService.hasReadAccess(this.mId,_pid);
  }
  loadPlan(){
    this._dataService.loadPlan(this.currMonthDtObj).subscribe((_dailyProdHigh: Plan) => {
      if (_dailyProdHigh != null) {
        this.planObj = _dailyProdHigh;
      }
    });
  }
  loadMonthData(){
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;
    this._dataService.loadCustmrInspPlan(this.currMonthDtObj).subscribe((_cstInspPlan:CustomerInspectionPlan) => {
        if(_cstInspPlan!=null){
          this.datatables = _cstInspPlan;
          this.loadDateData();

          let _tmpDailyTokenList: Array<DailyToken> = [];
          for (var i = 0; i < this.datatables.dayTokens.length; i++) {
            let _tmpDate:Date = this.datatables.dayTokens[i].selDate;
            let _tmpDailyTokens:Array<DailyTokenItem> = [];
            
            let _indexer:number = 0;
            this.datatables.dayTokens[i].dateTokens.forEach((_tmpObj:CIPToken) => {
              _tmpDailyTokens.push(new DailyTokenItem( this.getDisplayTokenName(_tmpObj.customerName,_tmpObj.quantity), this.getIdObj(_tmpDate,_indexer),''));
              _indexer++;
            });
            _tmpDailyTokenList.push(new DailyToken(_tmpDate, _tmpDailyTokens));
          }
  
          this.daywiseItemList = _tmpDailyTokenList;
          this.isLoaded = true;
          this.isLoading = false;
          this.isFailed = false;
        }
        else{
          this.daywiseItemList = null;
          this.isLoaded = false;
          this.isLoading = false;
          this.isFailed = true;
          this.failMessage = "Failed to get data from database, try again";
        }
    });
  }

  private getDisplayTokenName(_prodId:string,_quantity:number){
    return this._dataService.getCustomerName(_prodId) + ' ('+_quantity+')';
  }
  private getIdObj(_selDate:Date,_itemIndex:number){
    return {"selDate":_selDate,"rowIndex":_itemIndex}
  }
  
  ItemSelected(_evntObj){
    this.selView = 1;
    this.currMonthDtObj.setDate(_evntObj.selDate.getDate());
    this.loadDateData();
  }

  public showChildModal(_editToken:string,_param1:any,_param2:any):void {
    switch(_editToken){
      case "rowedit":
      this.btnName = "Done";
        this.editRow = _param1.cloneSelf();
        this.editType = _editToken;
        this.editHeader = "Edit Customer Inspection Plan (" + this.formatHeaderDate(this.dCIPDayTokenObj.selDate) +")";
      break;
      case "rownew":
      this.btnName = "Done";
        this.editRow = new CIPToken(null,null,null,0,0,null,this.currMonthDtObj.getTime(),null,(new Date()).getTime());
        this.editType = _editToken;
        this.editHeader = "Add Customer Inspection Plan (" + this.formatHeaderDate(this.dCIPDayTokenObj.selDate) +")";
      break;
      case "selplan":
      this.btnName = "Save";
        this.editText = this.planObj.description;
        this.editType = 'text';
        this.editHeader = "Edit Plan";
      break;
    }
    this.editParam1 = _param1;
    this.editParam2 = _param2;
    this.editToken = _editToken;
    this.childModal.show();
  }

  public addNewProdRow(_newRowToken: string, _selDate: Date) {
    switch (_newRowToken) {
      case "rownew":
        this.showChildModal(_newRowToken,null,null);
        break;
    }
  }
  public removeRecord( _tokenIndex:number) {
    this.dCIPDayTokenObj.removeToken(_tokenIndex); 
    this.areChangesMade = true;   
  }

  dataEdited(){
    switch(this.editToken){
      case "rowedit":
        if(this.editRow._date){
          this.editParam1.dateNum = this.editRow._date.getTime();
        }
        else{
          this.editParam1.dateNum = this.editRow.dateNum;
        }        
        this.editParam1.productName = this.editRow.productName;
        this.editParam1.customerName = this.editRow.customerName;
        this.editParam1.inspectionDoneBy = this.editRow.inspectionDoneBy;
        this.editParam1.quantity = this.editRow.quantity;
        this.editParam1.witnessQuantity = this.editRow.witnessQuantity;
        this.editParam1.cb = this.editRow.cb;
        this.editParam1.respPrsn = this.editRow.respPrsn;
        this.editParam1.creationDate = this.editRow.creationDate;
    break;
    case "rownew":
    this.datatables.addDateToken(new Date(this.currMonthDtObj),
                                   new CIPToken(this.editRow.productName,this.editRow.customerName,this.editRow.inspectionDoneBy,
                                                this.editRow.quantity,this.editRow.witnessQuantity,this.editRow.cb,this.editRow.date.getTime(),
                                                this.editRow.respPrsn,this.editRow.creationDate));

    break;
    case "selplan":
      this.datatables.plan = this.editText;
      this.planObj.description = this.editText;
      this.planObj.monthDateNum = this.currMonthDtObj.getTime();
      this.savePlan();      
    break;
    }
    this.areChangesMade = true;
    this.hideChildModal();
  }

  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }

  formatDate(_date:Date):string{
    if(_date)  return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    return '-';
  }

  public hideChildModal():void {
    this.childModal.hide();
  }

  public cancelSaveData():void {
     switch(this.editToken){
      case "rowedit":
      case "rownew":
        this.loadMonthData();
        this.loadPlan();
      }
      this.childModal.hide();
  }
  saveData(_sendMail: boolean): void {
    if (this.validateData() == true) {
      this._dataService.saveCustmrInspPlan(this.datatables, _sendMail).subscribe((resp: GenResponse) => {
        if (resp.status == DataService.statusFail) {
          if (resp.errorCode == DataService.staleDataCode) {
            this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
          } else {
            this._notify.error('Failure', resp.details, this._dataService.failureOptions);
          }
        }
        else {
          this._notify.success('Success', resp.details, this._dataService.successOptions);
          this.loadMonthData();
          this.loadPlan();
        }

      });
    }
  }
  savePlan() {
    this._dataService.savePlan(this.planObj).subscribe((resp: GenResponse) => {
      if (resp.status == DataService.statusFail) {
        if (resp.errorCode == DataService.staleDataCode) {
          this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
        } else {
          this._notify.error('Failure', resp.details, this._dataService.failureOptions);
        }
      }
      else {
        this._notify.success('Success', resp.details, this._dataService.successOptions);
        this.loadMonthData();
        this.loadPlan();
      }

    });
  }
  
  discardData():void{
    this.loadMonthData();
    this.loadPlan();
  }
  validateData():boolean{
    return true;
  }

  prevMonthSel():void{
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
    this.loadPlan();
  }
  nextMonthSel(){
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
    this.loadPlan();
  }

  prevDateSel():void{
    if(this.currMonthDtObj.getDate() > 1){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()-1);
      this.loadDateData();
    }
  }
  nextDateSel():void{
    var _tmpLastDayOfMonth:Date = new Date(this.currMonthDtObj.getFullYear(),this.currMonthDtObj.getMonth()+1,0);
    if(this.currMonthDtObj.getDate() < _tmpLastDayOfMonth.getDate()){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()+1);
      this.loadDateData();
    }
  }

  loadDateData():void{
    let _tmpDPHDayToken:CIPDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    if(_tmpDPHDayToken == null){
      this.datatables.addDateToken(this.currMonthDtObj);  
      _tmpDPHDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    }
    this.dCIPDayTokenObj = _tmpDPHDayToken;
  }

  public getSelYear(): number {
    return this.currMonthDtObj.getFullYear();
  }
  public getSelMonth(): number {
    return this.currMonthDtObj.getMonth() + 1;
  }
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }

  formatMonth(_dateObj:Date):string{
    if(_dateObj){
      return GenService.getDateFormatStr(_dateObj , "MMM-YYYY");
    }
    return '-';
  }
  getProductName(_prodId:string):string{
    if(_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }
  getCustomerName(_custId:string):string{
    if(_custId)
      return this._dataService.getCustomerName(_custId);
    return '';
  }
  getInspectionDoneBy(_inspId:string):string{
    if(_inspId)
      return this._dataService.getInspectionDoneBy(_inspId);
    return '';
  }
  getData(option){
     if(option) return option
     return ''
  }
  getResponsiblePrsn(_prsn:string):string{
    if(_prsn) return this._dataService.getResponsiblePrsn(_prsn); 
    return ''
  }
  getTypeReady(_id:string):string{
    if(_id) return this._dataService.getTypeReady(_id)
    return ''
  }
  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    } else {
        return null;
    }
  }

}
